import { api } from "api/api";
import { AxiosError } from "axios";
import Pessoa from "model/administracao/cadastro/Pessoa";
import Produto from "model/administracao/cadastro/produto/Produto";
import ProdutoCliente from "model/fiscal/ProdutoCliente";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ProdutoClienteService implements BaseServiceCadastros<ProdutoCliente> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            const url = `/produtoCliente/pesquisar${getFilters(filters)}`;
            const params = { page: page.page, size: page.size, sort: page.sort };
            api.get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ProdutoCliente>((resolve, reject): void => {
            api.get(`/produtoCliente/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(produtoCliente: ProdutoCliente) {
        return new Promise<ProdutoCliente>((resolve, reject): void => {
            api.post(`/produtoCliente/incluir`, JSON.stringify(produtoCliente))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(produtoCliente: ProdutoCliente) {
        return new Promise<ProdutoCliente>((resolve, reject): void => {
            api.put(`/produtoCliente/editar`, JSON.stringify(produtoCliente))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api.delete(`/produtoCliente/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    produtos() {
        return new Promise<Produto[]>((resolve, reject): void => {
            api.get(`/produtoCliente/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    clientes() {
        return new Promise<Pessoa[]>((resolve, reject): void => {
            api.get(`/produtoCliente/clientes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default ProdutoClienteService;
